import React, { Component } from "react";
import Button from "../../../../../modules/commons/Button";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import PeriodeFilter from "../../common/periodeFilter";
import { getColumns, formGroup } from "./config";
import TabBBKDetail from "./tabBBKDetail";
import FlexView from "react-flexview";
import { FormatCurrencyWithoutSymbol } from "../../../../../Services/Utils";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as R from "ramda";

class TabBBKBelumRealisasi extends Component {
    tableColumns = [
        ...getColumns("BELUM REALISASI"),
        {
            name: "paymentId",
            label: "Aksi",
            options: {
                customBodyRender: (val,{rowIndex}) => {
                    const isOnApproval = this.props.state.dataTable[rowIndex]?.inApproval;
                    return (
                        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <Button className="btnAct" onClick={() => this.handleDetailVisibility(val)}>
                                <i
                                    className="fa fa-lg fa-eye"
                                    style={{
                                        fontSize: 20,
                                        color: 'red'
                                    }}
                                />
                            </Button>
                                <>
                                {this.props.userAccess?.updateAccess && (
                                    <Button className="btnAct" disabled={isOnApproval} onClick={() => this.handleDetailVisibility(val, true)}>
                                        <i
                                            className="fa fa-lw fa-pencil-alt"
                                            style={{
                                                fontSize: 20,
                                                color: isOnApproval ? "grey" : 'red'
                                            }}
                                        />
                                    </Button>
                                )}
                                {this.props.userAccess?.createAccess && (
                                    <Button 
                                        disabled={isOnApproval}
                                        className="btnAct"
                                        onClick={() => this.handleDetailVisibility(val, false, "realisasi")}>
                                        <i
                                            className="fa fa-file-signature"
                                            style={{
                                                fontSize: 20,
                                                color: isOnApproval ? "grey" : 'red'
                                            }}
                                        />
                                    </Button>
                                )}
                                {this.props.userAccess?.updateAccess && (
                                    <Button 
                                        disabled={isOnApproval}
                                        className="btnAct" onClick={() => this.handleDetailVisibility(val, false, "batal")}>
                                       <span
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            color: isOnApproval ? "grey" : 'red',
                                          }}
                                        >
                                          X
                                        </span>
                                    </Button>
                                )}
                                </>
                        </div>
                    );
                },
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            filterVisible: false,
            isEditable: false,
            detailId: "",
            sourcePayment: null
        };
    }

    handleDetailVisibility = (id = "", editable = false, action = "") => {
        if (R.isNil(id)) {
            this.props.onRefresh();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            detailId: id,
            isEditable: editable,
            modifyingVisible: !prevValue.modifyingVisible,
            action: action,
        }));
    };

    render() {
        return (
            <div>
                <PeriodeFilter
                    {...this.props}
                    withFilterButton
                    startDateName="tanggalAwal"
                    endDateName="tanggalAkhir"
                    onValueChange={this.props.onPeriodChange}
                    onSubmit={this.props.onSubmitPeriod}
                    onShowFilter={this.props.onShowFilter}
                />
                <SimpleDataTable
                    data={this.props.state.dataTable}
                    columns={this.tableColumns}
                    rowsPerPage={this.props.state.pagination.limit}
                    page={this.props.state.pagination.page - 1}
                    toCount={this.props.state.pagination.totalData}
                    options={defaultTableChange(this.props.onChangePage, this.props.onChangeRowsPerPage)}
                />
                <FlexView vAlignContent={"center"} hAlignContent={"right"} style={{ marginTop: "20px" }}>
                    <FlexView>
                        <div className="margin-5px">
                            <div className="txt-site txt-11 txt-main txt-bold">
                                <h4>Total Nilai BBK BELUM REALISASI (Rp)</h4>
                            </div>
                        </div>
                        <input
                            disabled
                            type="text"
                            className="txt txt-sekunder-color"
                            value={FormatCurrencyWithoutSymbol({ number: this.props.state.totalPayment })}
                        />
                    </FlexView>
                    {this.props.userAccess?.createAccess && (
                        <SimpleButton
                             text="Tambah"
                             onClick={() => {
                                 this.setState({ sourcePayment: "PAYMENT" })
                                 this.handleDetailVisibility("", true)
                             }}
                        />
                    )}
                </FlexView>
                {this.state.modifyingVisible && (
                    <TabBBKDetail
                        formGroup={formGroup}
                        sourcePayment={this.state.sourcePayment}
                        title="Detail BBK BELUM REALISASI"
                        paymentStatus={"BELUM_REALISASI"}
                        id={this.state.detailId}
                        action={this.state.action}
                        visible={this.state.modifyingVisible}
                        namaCabang={this.props.kodeCabang}
                        kodeCabang={this.props.kodeCabang?.value}
                        isEditable={this.state.isEditable}
                        onClickClose={(value) => {
                            this.handleDetailVisibility(value)
                            this.setState({ sourcePayment: null })
                        }}
                    />
                )}
            </div>
        );
    }
}

export default TabBBKBelumRealisasi;
